import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private httpClient: HttpClient) {}

  getOrganisationRoles(organisationId: number){
    return this.httpClient
      .get(`${environment.apiUrl}organisation-roles/by-organisation/${organisationId}`)
  }

  getAuthorizationCodes(organisationId: number | null, data: object) {
    return organisationId ?
      this.httpClient
        .post(`${environment.apiUrl}authorization-codes/mappings-by-organisation?organisationId=${organisationId}`, data)
      :
      this.httpClient
        .post(`${environment.apiUrl}authorization-codes/mappings-by-organisation`, data)
  }

  setRoleToAuthorizationCode(organisationId: number | null, roleId: number, authorizationCodes: number[]){
    return organisationId ?
      this.httpClient
        .put(`${environment.apiUrl}organisation-roles/update-organisation-role-mappings/${organisationId}/${roleId}`, authorizationCodes)
      :
      this.httpClient
        .put(`${environment.apiUrl}system-roles/update-system-role-mappings/${roleId}`, authorizationCodes);
  }

  getSystemRoles(){
    const headers = { 'X-Skip-Interceptor-Error': 'true' };
    return this.httpClient
      .post(`${environment.apiUrl}system-roles/filter`, {}, { headers });
  }
}
